import { selector, atom } from 'recoil'
import { performanceClient } from 'src/clients'
import { DEFAULT_LRU_SIZE, keyFactory, retryAtom, uncachedSelector } from 'src/utils/recoil'
import { venueMatch } from 'src/atoms/search'
import { VenuePerformanceCategory, VenuePerformanceInfo } from 'src/common-services'
import { ifNotFound } from 'src/utils/ajax'

const key = keyFactory('performance')

const venue = uncachedSelector<VenuePerformanceInfo | null>({
  key: key('venue'),
  get: ({ get }) => {
    get(retryAtom)
    const match = get(venueMatch)
    if (!match) {
      return null
    }
    const { venueId } = match
    // TODO: Modify the backend to filter by id this request
    return ifNotFound(performanceClient.getVenueInfo({ venueId }), null)
  },
  lru: DEFAULT_LRU_SIZE,
})

export const venueCategories = selector<VenuePerformanceCategory[]>({
  key: key('venue-categories'),
  get: ({ get }) => {
    const ven = get(venue)
    if (!ven) {
      return []
    }
    return ven.categories
  },
})

const userSelectedCategory = atom<string | undefined>({
  key: key('user-selected-category'),
  default: undefined,
})

export const selectedCategory = selector<string>({
  key: key('selected-category'),
  get: ({ get }) => {
    const userSelected = get(userSelectedCategory)
    if (userSelected) {
      return userSelected
    }
    const match = get(venueMatch)
    if (!match) {
      return ''
    }
    const ven = get(venue)
    if (!ven) {
      return ''
    }
    // default to use the category from the venue based on the naics
    return ven.categories.find((x) => x.code === ven.details.category)?.code ?? ven.categories[0]?.code ?? ''
  },
  set: ({ set }, value) => {
    if (!value) {
      return
    }
    set(userSelectedCategory, value)
  },
})
